export const findNestedObjectValue = (obj: any, key: string | undefined) => {
  if (!key) return obj;
  const keyChain: string[] = key.split('.');
  return _findNestedObjectValueRecursive(obj, keyChain);
};

const _findNestedObjectValueRecursive = (
  obj: any,
  keyChain: string[]
): any | undefined => {
  if (!obj || !keyChain?.length) return obj;

  const [key, ...rest] = keyChain;
  const keyValue = obj?.[key];

  if (!rest.length) return keyValue;

  return _findNestedObjectValueRecursive(keyValue, rest);
};
